export const ACTIVITY_EVENTS = {
  sent: {
    id: 'sent',
    icon: 'os-icon-send',
    iconTooltip: 'label.TOOLTIP.EMAIL_SENT',
    label: 'label.EMAIL_SENT',
    message: 'label.MESSAGE.EMAIL_SENT',
    notification: 'label.NOTIFICATION.EMAIL_SENT',
    color: '#777777',
    weight: 0
  },
  viewed: {
    id: 'viewed',
    icon: 'os-icon-eye',
    iconTooltip: 'label.EMAIL_VIEWS',
    label: 'label.EMAIL_VIEW',
    message: 'label.MESSAGE.EMAIL_VIEW',
    notification: 'label.NOTIFICATION.EMAIL_VIEW',
    color: '#1c90f8',
    weight: 3
  },
  viewerlaunched: {
    id: 'viewerlaunched',
    icon: 'os-icon-external-link',
    iconTooltip: 'label.TOOLTIP.DOCUMENTS_VIEWED',
    label: 'label.DOCUMENT_VIEW',
    message: 'label.MESSAGE.DOCUMENTS_VIEWED',
    notification: 'label.NOTIFICATION.DOCUMENTS_VIEWED',
    color: '#d6b74a',
    weight: 5
  },
  myplayerlaunched: {
    id: 'myplayerlaunched',
    icon: 'os-icon-external-link',
    iconTooltip: 'label.TOOLTIP.VIDEOS_VIEWED',
    label: 'label.VIDEO_LAUNCHED',
    message: 'label.MESSAGE.VIDEOS_VIEWED',
    notification: 'label.NOTIFICATION.VIDEOS_VIEWED',
    color: '#d6b74a',
    weight: 5
  },
  adclick: {
    id: 'adclick',
    icon: 'os-icon-target',
    iconTooltip: 'label.AD_CLICKS',
    label: 'label.AD_CLICK',
    message: 'label.MESSAGE.AD_CLICK',
    notification: 'label.NOTIFICATION.AD_CLICK',
    color: '#35cd8d',
    weight: 4
  },
  linkclick: {
    id: 'linkclick',
    icon: 'os-icon-link',
    iconTooltip: 'label.TOOLTIP.LINK_CLICK',
    label: 'label.LINK_CLICK',
    message: 'label.MESSAGE.LINK_CLICK',
    notification: 'label.NOTIFICATION.LINK_CLICK',
    color: '#50bAb4',
    weight: 4
  },
  slideviewed: {
    id: 'slideviewed',
    icon: 'os-icon-eye',
    iconTooltip: 'label.TOOLTIP.DOCUMENT_PAGE_VIEW',
    label: 'label.DOCUMENT_PAGE_VIEW',
    message: 'label.MESSAGE.DOCUMENT_PAGE_VIEW',
    notification: 'label.NOTIFICATION.DOCUMENT_PAGE_VIEW',
    color: '#e7ca65',
    weight: 5
  },
  websitevisit: {
    id: 'websitevisit',
    icon: 'os-icon-globe',
    iconTooltip: 'label.TOOLTIP.WEBSITE_VISIT',
    label: 'label.WEBSITE_VISIT',
    message: 'label.MESSAGE.WEBSITE_VISIT',
    notification: 'label.NOTIFICATION.WEBSITE_VISIT',
    color: '#fd8e82',
    weight: 5
  },
  downloaded: {
    id: 'downloaded',
    icon: 'os-icon-download',
    iconTooltip: 'label.TOOLTIP.DOCUMENT_DOWNLOAD',
    label: 'label.DOCUMENT_DOWNLOAD',
    message: 'label.MESSAGE.DOCUMENT_DOWNLOAD',
    notification: 'label.NOTIFICATION.DOCUMENT_DOWNLOAD',
    color: '#9A79C5',
    weight: 5
  },
  videoactivity: {
    id: 'videoactivity',
    icon: 'os-icon-video',
    iconTooltip: 'label.TOOLTIP.VIDEO_ACTIVITY',
    label: 'label.VIDEO_VIEW',
    message: 'label.MESSAGE.VIDEOS_VIEWED',
    notification: 'label.NOTIFICATION.VIDEO_ACTIVITY',
    color: '#e7ca65',
    weight: 3
  },
  // Business card events. `icon` holds a Lucide glyph class rather than an
  // `os-icon-*` one: both render sites splat this value straight into `class=`,
  // so it converts to <Icon name="contact" /> when the Lucide migration reaches
  // activity-history/item-event and activity-event-icons.
  bizcardvisit: {
    id: 'bizcardvisit',
    icon: 'icon-contact',
    iconTooltip: 'label.BIZCARD_VIEWS',
    label: 'label.BIZCARD_VIEW',
    message: 'label.MESSAGE.BIZCARD_VIEW',
    notification: 'label.NOTIFICATION.BIZCARD_VIEW',
    color: '#f2994a',
    weight: 5
  },
  // Synthesized in response.js from a bizcardvisit whose note.src === 'qr'.
  // A QR scan therefore counts as both a view and a scan.
  bizcardscan: {
    id: 'bizcardscan',
    icon: 'icon-qr-code',
    iconTooltip: 'label.BIZCARD_SCANS',
    label: 'label.BIZCARD_SCAN',
    message: 'label.MESSAGE.BIZCARD_SCAN',
    notification: 'label.NOTIFICATION.BIZCARD_SCAN',
    color: '#d94f9a',
    weight: 5
  }
};
